import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import SolicitacaoService from '../../../../services/solicitacao'
import Solicitacao from './solicitacao';
import '../../../../styles/diario.scss';
import FormBusca from './busca';
import { Navigate } from 'react-router-dom';


const SolicitScreen = () => {

    const [solicitacoes, setSolicitacoes] = useState([]);
    const [solicitacoesOriginais, setSolicitacoesOriginais] = useState([]);
    const [ver, setVer] = useState(false);
    const [editar, setEditar] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [solicitacao, setSolicitacao] = useState("");
    const [loading, setLoading] = useState(false);
    const [resp, setResp] = useState(false);
    const [numeroPreview, setNumeroPreview] = useState("");

    const pathName = window.location.pathname;

    async function fetchNumero() {
        const res = await SolicitacaoService.previewNumero();
        setNumeroPreview(res.data.numero);
    }

    async function fetchSolicitacoes() {
        await fetchNumero()
        setLoading(true);
        const response = await SolicitacaoService.listar();
        if (pathName === "/especificacoes/ti/solicitacao/respondidas") {
            if (response.data["resolvidas"]) {
                setResp(true)
                setSolicitacoes(response.data["resolvidas"]);
                setSolicitacoesOriginais(response.data["resolvidas"]);
                setLoading(false);
                setVazio(false);
            } else {
                setLoading(false);
                setSolicitacoes([]);
                setSolicitacoesOriginais([]);
                setVazio(true);
            }
        } else if (pathName === "/especificacoes/ti/solicitacao/pendentes") {
            if (response.data["pendentes"]) {
                setSolicitacoes(response.data["pendentes"]);
                setSolicitacoesOriginais(response.data["pendentes"]);
                setLoading(false);
                setVazio(false);
            } else {
                setLoading(false);
                setSolicitacoes([]);
                setSolicitacoesOriginais([]);
                setVazio(true);
            }
        }
    }

    const filtrarLocalmente = (secretaria, processo) => {

        // Se todos vazios → voltar ao original
        if (!secretaria.trim() && !processo.trim()) {
            setSolicitacoes(solicitacoesOriginais);
            setVazio(false);
            return;
        }

        const filtrados = solicitacoesOriginais.filter(f => {

            const matchSecretaria = secretaria.trim()
                ? f.secretaria.toLowerCase().includes(secretaria.toLowerCase())
                : true;

            const matchProcesso = processo.trim()
                ? String(f.processo).includes(processo)
                : true;
            return matchSecretaria && matchProcesso;
        });

        if (filtrados.length >= 1) {
            setSolicitacoes(filtrados);
            setVazio(false);
        } else {
            setSolicitacoes([]);
            setVazio(true);
        }
    };

    const handleVer = (id) => {
        setSolicitacao(id);
        setVer(true)
    }

    const handleEditar = (id) => {
        setSolicitacao(id);
        setEditar(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir a solicitação?')) {
            try {
                await SolicitacaoService.deletar(id)
                alert("Solicitação deletada com sucesso!")
                fetchSolicitacoes();
            } catch (err) {
                alert("Algo deu errado ao deletar a solicitação!")
            }
        }
    }

    const voltarPen = async (id) => {
        if (window.confirm('Tem certeza que deseja voltar a solicitação para pendente?')) {
            try {
                await SolicitacaoService.editar(id, { situacao: "Pendente" })
                alert("Solicitação editada com sucesso!")
                fetchSolicitacoes();
            } catch (err) {
                alert("Algo deu errado ao editar a solicitação!")
            }
        }
    }

    useEffect(() => {
        fetchSolicitacoes();
    }, [window.location.pathname]);

    if (ver) {
        return (
            <Navigate to={`/ti/solicitacao/${solicitacao}/componentes`} />
        )
    }
    if (editar) {
        return (
            <Navigate to={`/ti/solicitacao/editar/${solicitacao}`} />
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <FormBusca
                            fetchSolicitacoes={fetchSolicitacoes}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                        <br />
                        <br />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br />
                            <Table className="table table-bordered tabela-rh">
                                <thead>
                                    <tr>
                                        <th>Nº Solicitação</th>
                                        <th>Secretaria</th>
                                        <th>Responsável</th>
                                        <th>Memorando</th>
                                        <th>Data Criação</th>
                                        <th>Ver</th>
                                        {resp ?
                                            <Fragment>
                                                <th>Ver Mem.</th>
                                                <th>Voltar Pendente</th>
                                            </Fragment> :
                                            <Fragment><th>Editar</th>
                                                <th>Criar Mem.</th>
                                            </Fragment>
                                        }
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {solicitacoes.map((solicitacao, index) =>
                                        <Solicitacao
                                            solicitacao={solicitacao}
                                            key={index}
                                            ver={handleVer}
                                            editar={handleEditar}
                                            deletar={deletar}
                                            voltarPen={voltarPen}
                                            numeroPreview={numeroPreview}
                                            fetchSolicitacoes={fetchSolicitacoes}
                                        />
                                    )}
                                </tbody>
                            </Table>
                            {loading && (
                                <Container className="text-center mt-5">
                                    <div className="d-flex justify-content-center">
                                        <div className="spinner-border" role="status" />
                                    </div>
                                    <p className="mt-3">⏳ Carregando dados, aguarde...</p>
                                </Container>

                            )}
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default SolicitScreen;